exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-3d83a4c2]{width:30%;padding:20px;box-shadow:0 8px 16px 0 rgba(0,0,0,.2);background-color:#fff;margin:auto;position:absolute;top:0;left:0;bottom:0;right:0;height:400px}@media screen and (max-width:1024px){.container[data-v-3d83a4c2]{width:80%}img[data-v-3d83a4c2]{width:70%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d83a4c2","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Sessions/PermissionAuth/Index.vue
// module id = 158
// module chunks = 2